import type { TOC } from '@ember/component/template-only';
import { PrismBadge } from '@mylighthouse/prism-ember';
import type { CustomEmberTableColumn } from '@mylighthouse/prism-ember/types/components/prism/table';
import { t } from 'ember-intl';

interface HotelPricingAssistantTableCellsThBaseRoomMonthSignature {
  Args: {
    column: CustomEmberTableColumn;
  };
}

const HotelPricingAssistantTableCellsThBaseRoomMonth = <template>
  <div class="flex items-center justify-center gap-200">
    <span>{{@column.name}}</span>
    <div class="text-nowrap">
      <PrismBadge
        @label={{t
          "pricing_assistant.settings.panel.section.rooms.leading_room"
        }}
        @type="neutral"
        data-test-id="base-room-badge"
      />
    </div>
  </div>
</template> satisfies TOC<HotelPricingAssistantTableCellsThBaseRoomMonthSignature>;

export default HotelPricingAssistantTableCellsThBaseRoomMonth;
